import Ps from 'perfect-scrollbar';

class Filters {
    constructor($) {
        // Environment variables
        this.$ = $;

        // Document
        this.$window = this.$(window);

        // Elements
        this.$filterItems = this.$('.js-filter-items').once();

        if (this.$('body').hasClass('employers-child-theme')) {
            const $caseStudyCheckbox = document.querySelector('[value="case_study"]');

            if ($caseStudyCheckbox && !$caseStudyCheckbox.checked) {
                this.HideRegionFilter();
            }

            this.checkFilterLabel();
        }

        // Scrollbars
        //----------------------------------------
        this.scrollbars = [];

        if (!this.$('html').hasClass('no-classlist')) {
            this.addScrollbars();
            // // On load init the scrollbars
            this.$window.on('load', this.$.proxy(this.addScrollbars, this));

            this.$window.on('resize', this.$.proxy(this.updateScrollbars, this));
        }

        // Events
        //----------------------------------------
        this.$('body').unbind('click').on('click', '.js-filter-header', (e) => {
            this.toggleFilters(e);

            if (!this.$('html').hasClass('no-classlist')) {
                this.addScrollbars();
            }
        });
    }

    HideRegionFilter() {
        const buttons = document.getElementsByClassName('js-filter-header');

        if (buttons.length > 0) {
            for (const button of buttons) {
                const filterButtonText = button.innerText.trim();
                const buttonParent = button.parentNode;

                if (filterButtonText === 'Region') {
                    buttonParent.classList.add('is-hidden');
                }
            }
        }
    }

    checkFilterLabel() {
        const labels = document.getElementsByClassName('c-filters__item-label');
        for (const label of labels) {
            const labelContent = label.innerText.trim();
            if (labelContent === 'Case Study') {
                label.addEventListener('click', () => {
                    const buttons = document.getElementsByClassName('js-filter-header');

                    if (buttons.length > 0) {
                        for (const button of buttons) {
                            const filterButtonText = button.innerText.trim();
                            const buttonParent = button.parentNode;
                            const isHidden = buttonParent.classList.contains('is-hidden');

                            if (isHidden) {
                                buttonParent.classList.remove('is-hidden');
                            } else {
                                if (!isHidden && (filterButtonText === 'Region')) {
                                    buttonParent.classList.add('is-hidden');
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    toggleFilters(e) {
        e.preventDefault();
        const $elem = this.$(e.currentTarget);
        const elemText = $elem.text().trim();

        $elem.next().slideToggle(300, () => {
            if (!this.$('html').hasClass('no-classlist')) {
                this.updateScrollbars();
            }
        }).toggleClass('is-open');

        $elem.toggleClass('is-clicked');

        if ($elem.hasClass('is-clicked')) {
            $elem.attr('aria-expanded', 'true');
        } else {
            $elem.attr('aria-expanded', 'false');
        }
    }

    addScrollbars() {
        this.$filterItems = this.$('.js-filter-items');
        for (let i = 0; i < this.$filterItems.length; i++) {
            this.scrollbars.push(new Ps(this.$filterItems[i]));
        }
    }

    updateScrollbars() {
        this.scrollbars.forEach((ps) => ps.update());
    }
}

export default Filters;
